import { Pipe, PipeTransform } from '@angular/core';

const BATTERY = { icon: 'battery-alert', cssClass: 'alert-battery' };
const POWER = { icon: 'power-alert', cssClass: 'alert-power' };
const CONNECTIVITY = {
  icon: 'connectivity-alert',
  cssClass: 'alert-connectivity',
};

@Pipe({
  name: 'alertCategory',
  pure: true,
  standalone: true,
})
export class AlertCategoryPipe implements PipeTransform {
  transform(categoryName: string): { icon: string; cssClass: string } {
    const name = (categoryName || '').toLowerCase();

    switch (true) {
      case name.includes('battery'):
        return BATTERY;

      case name.includes('motor') || name.includes('controller'):
        return {
          icon: 'motor-alert',
          cssClass: 'alert-motor',
        };

      case name.includes('power') || name.includes('performance'):
        return POWER;

      case name.includes('speed') ||
        name.includes('stoppage') ||
        name.includes('driving'):
        return {
          icon: 'driving-alert',
          cssClass: 'alert-driving',
        };

      case name.includes('connectivity') || name.includes('telematic'):
        return CONNECTIVITY;

      case name.includes('efficiency'):
        return BATTERY;

      case name.includes('utilization'):
        return POWER;

      case name.includes('trip'):
        return CONNECTIVITY;

      default:
        return {
          icon: '',
          cssClass: '',
        };
    }
  }
}
